import { Component, input } from '@angular/core'

@Component({
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false,
})
export class ErrorComponent {
  protected api = input.required<{
    error: string
  }>()
}
